import { useState } from 'react';
import { CSVLink } from 'react-csv';
import Table from 'react-bootstrap/Table';

import { Link } from 'react-router-dom';

import UploadCSV from 'components/LM/common/UploadCSV';
import K2Api from 'lib/ajax/K2Api';
import { useK2Loader } from 'hooks/useK2Loader';
import Loader from 'components/Loader';
import Breadcrumb from "components/LM/common/Breadcrumb";


const k2Api = new K2Api();
function Upload() {
	const [file, setFile] = useState(null);

	const [uploading, setUploading] = useState(false);
	const [success, setSuccess] = useState(false);
	const [error, setError] = useState(null);

	const [loadingLabels, labelsResponse] = useK2Loader('/labels');
	if (loadingLabels) return <Loader />;

	const labels = labelsResponse.map(label => label.name);

	const onSubmit = async () => {
		setError(null);
		const formData = new FormData();
		formData.append('file', file);
		setUploading(true);
		k2Api.post("/socialmedia/import", formData)
			.then(() => {
				setSuccess(true)
			}).catch(error => {
				setError(error.response.data);
			}).finally(() => setUploading(false))
	}


	const onSetFile = (file) => {
		setSuccess(false);
		setError(null);
		setFile(file);
	}

	const breadcrumbPage = <Breadcrumb items={['Orphan', 'Mass Import']} />;

	return (
		<UploadCSV breadcrumb={breadcrumbPage} onSubmit={onSubmit} onSetFile={onSetFile} file={file} importStatusLink={"/orphan/import/status"} submitStatus={{ uploading, success, error }} deprecated={<>This importer is no longer available. Please use the <Link to="/voices/new-import">new Mass Import</Link> to upload your file.</>}>
			<>
				<p>The first row indicates the column content. There should be one account per line.</p>
				<p><strong>The limit of the csv file is 5.000 rows</strong></p>
				<br />
				<p>The accepted column names are:</p>
				<Table striped bordered>
					<thead>
						<tr>
							<th>Column name</th>
							<th>Note</th>
						</tr>
					</thead>
					<tbody>
						<tr>
							<td>url</td>
							<td>
								<ul>
									<li>instagram</li>
									<li>tiktok</li>
									<li>facebook</li>
									<li>youtube</li>
									<li>weibo</li>
									<li>douyin</li>
									<li>xiaohongshu</li>
									<li>bilibili</li>
									<li>wechat_public</li>
								</ul>
							</td>
						</tr>
						<tr>
							<td>labels</td>
							<td>{labels.join(', ')}</td>
						</tr>
					</tbody>
				</Table>
				<p>You can download an <SampleDownload /> to use as a template</p>
				<br />
				<h4>How does it work</h4>
				<p>With this feature, you can import new profiles</p>
				<ul>
					<li>one of network url <span className="text-danger">*</span></li>
					<li>labels</li>
				</ul>
				<p><span className="text-danger">*</span> Mandatory field</p>
				<br />
				<h4>FAQ</h4>
				<p><b>Can I put more than one label per profile_url? </b>
					Yes, you can add more labels using the semicolon separator in the labels column.
					Ex: <b>type.brand;type.journalist</b>
				</p>
			</>
		</UploadCSV>
	);
}

function SampleDownload() {
	const data = [
		['url', 'labels'],
		['instagram url', 'type.brand'],
		['tiktok url', 'type.brand;type.journalist'],
		['tiktok url', ],
		['weibo url', 'pkl_type.beauty_fragrance'],
		['wechat_public url', 'pkl_type.travel']
	];
	return <CSVLink data={data} separator={","} filename={"orphan_example.csv"} uFEFF={false}>example</CSVLink>
}

export default Upload;
